module.exports = __webpack_public_path__ + "static/media/movie1.c927c434.mp4";